export * from './forecast.service';
import { ForecastService } from './forecast.service';
export * from './hello.service';
import { HelloService } from './hello.service';
export const APIS = [ForecastService, HelloService];
